module.exports = "/_next/static/images/OgRecipes-4dbc025ed73c6e52399c0da62a980448.png";